import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export function ExchangeBadge({ className }: { className?: string }) {
  return (
    <Badge
      variant="outline"
      className={cn(
        "font-medium bg-amber-500/10 text-amber-700 border-amber-500/30",
        className,
      )}
    >
      ZAMJENSKA
    </Badge>
  );
}
